<!-- Required -->
@if (
  formGroup &&
  !formGroup.controls[field].valid &&
  formGroup.controls[field].touched &&
  formGroup.controls[field].errors.required
  ) {
  {{
  'general.requiredMsg'
  | translate: { field: translatePfx + '.' + field | translate }
  }}
}

<!-- Pattern -->
@if (
  formGroup &&
  !formGroup.controls[field].valid &&
  formGroup.controls[field].touched &&
  formGroup.controls[field].errors.pattern
  ) {
  {{
  'general.patternMsg'
  | translate: { field: translatePfx + '.' + field | translate }
  }}
}

<!-- Max Lenght -->
@if (
  formGroup &&
  !formGroup.controls[field].valid &&
  formGroup.controls[field].touched &&
  formGroup.controls[field].errors.maxlength
  ) {
  {{
  'general.maxlengthMsg'
  | translate: { field: translatePfx + '.' + field | translate }
  }}
}
